import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";

const SteamVideoSafetyContext = createContext({
  showNsfwVideos: false,
  toggleNsfwVideos: () => {},
});

export function SteamVideoSafetyProvider({ children }) {
  const { currentUser } = useAuth();
  const owner = currentUser?.id ?? currentUser?.sub ?? currentUser?.email;
  const [preference, setPreference] = useState(null);

  useEffect(() => {
    setPreference(null);
  }, [owner, currentUser?.is_admin]);

  const showNsfwVideos = Boolean(
    currentUser?.is_admin && owner != null &&
    preference?.owner === owner && preference.show
  );
  const toggleNsfwVideos = () => {
    if (!currentUser?.is_admin || owner == null) return;
    setPreference({ owner, show: !showNsfwVideos });
  };

  return (
    <SteamVideoSafetyContext.Provider value={{ showNsfwVideos, toggleNsfwVideos }}>
      {children}
    </SteamVideoSafetyContext.Provider>
  );
}

export const useSteamVideoSafety = () => useContext(SteamVideoSafetyContext);
